module.exports = __webpack_public_path__ + "img/arrow-left-20x20.3e0d03db.svg";